export const APP_ENV = import.meta.env.VITE_VERCEL_ENV ?? 'development';
export const APP_URL_PASS = import.meta.env.VITE_PASS_URL
export const APP_NAME = 'amo-espace-afn'
